function initializeMiraBuyNow() {
  document.querySelectorAll('[data-mira-buy-now]').forEach((button) => {
    if (button.dataset.initialized === 'true') {
      return;
    }

    button.dataset.initialized = 'true';

    button.addEventListener('click', async (event) => {
      event.preventDefault();
      event.stopPropagation();

      const productForm = button.closest('form');

      if (!productForm) {
        console.error('Formulaire produit introuvable.');
        alert('Impossible de trouver le produit.');
        return;
      }

      const variantInput = productForm.querySelector('[name="id"]');
      const quantityInput = productForm.querySelector('[name="quantity"]');

      const variantId = Number(variantInput?.value);
      const quantity = Math.max(1, Number(quantityInput?.value || 1));

      if (!variantId) {
        alert('Veuillez sélectionner une variante.');
        return;
      }

      const originalText = button.textContent;

      button.disabled = true;
      button.textContent = 'Préparation…';

      try {
        const response = await fetch(
          `${window.Shopify.routes.root}cart/add.js`,
          {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              Accept: 'application/json'
            },
            body: JSON.stringify({
              items: [
                {
                  id: variantId,
                  quantity
                }
              ]
            })
          }
        );

        if (!response.ok) {
          const errorBody = await response.text();
          throw new Error(errorBody);
        }

        const addedItems = await response.json();
        console.log('Produit ajouté :', addedItems);

        window.location.href = '/pages/finaliser-ma-commande';
      } catch (error) {
        console.error('Erreur Acheter maintenant :', error);

        alert(
          'Le produit n’a pas pu être ajouté au panier. Veuillez réessayer.'
        );

        button.disabled = false;
        button.textContent = originalText;
      }
    });
  });
}

document.addEventListener('DOMContentLoaded', initializeMiraBuyNow);
document.addEventListener('shopify:section:load', initializeMiraBuyNow);